import { useContext, useEffect, useState } from "react";
import { Routes, Route, useParams, useNavigate, Link } from "react-router-dom";
import Nav from '../../components/breadcrumb';
import { ErrorLoading, PageLoading } from "../../components/loading";
import PageHeader, { Title, ActionBar, ActionButton as Btn, ButtonToolbar } from '../../components/pageheader';
import { ConfirmAction } from "../../components/prompt";
import { errorAlert, infoAlert, successAlert } from "../../components/toastr";
import { AppUserContext } from "../../App";
import { deleteProject, getProject } from "../../resources/api/projects";
import { EditProject } from "./project-manipulation";
import { Table } from "react-bootstrap";
import moment from "moment";
import { UCWords } from "../../components/resources";



/**
 * 
 * @param {Object} props
 * @param {import("../../resources/api/projects").ProjectObject} props.details
 * @param {React.Dispatch<React.SetStateAction<import("../../resources/api/projects").ProjectObject>>} props.setDetails
 */
const ViewDetails = ({ details, setDetails }) => {

    const nav_items = [
        { title: 'Projects', href: "/app/projects" },
        { title: details.title }
    ];

    const { profile } = useContext(AppUserContext);
    const navigate = useNavigate();


    const handleProjectDelete = () => {

        infoAlert('Deleting project, please hold...');

        deleteProject(details.id)
            .then(({ message }) => {
                successAlert(message);
                navigate("/app/projects");
            })
            .catch(e => errorAlert(e));
    }



    return (
        <>
            <Nav items={nav_items} />

            <PageHeader maxWidth="1000">
                <Title><span dangerouslySetInnerHTML={{ __html: details.title }} /></Title>
                <ActionBar>
                    <ButtonToolbar>
                        <Btn href={`/app/jobs/new?project=${details.id}`} title="New Project Job">
                            <i className="fas fa-calendar-plus" />
                        </Btn>
                    </ButtonToolbar>
                    <ButtonToolbar>
                        {(
                            (profile.permission_level === 1)
                        ) &&
                            <ConfirmAction
                                as={Btn}
                                title="Delete Project"
                                confirmationText="Are you sure you want to delete this project?"
                                handleAction={handleProjectDelete}
                            >
                                <i className="fas fa-trash-alt" />
                            </ConfirmAction>
                        }
                        <Btn href={`/app/projects/${details.id}/edit`} title="Edit Details">
                            <i className="fas fa-pencil-alt" />
                        </Btn>
                        <Btn href="/app/projects/new" title="New Project">
                            <i className="fas fa-plus-circle" />
                        </Btn>
                    </ButtonToolbar>
                </ActionBar>
            </PageHeader>

            <div className="max-1000">
                <h4>{details.title} Details</h4>
                <dl>
                    <dt>Code</dt>
                    <dd>{details.code}</dd>
                    <dt>Client</dt>
                    <dd><Link to={`/app/clients/${details.client_id}`}>{details.client.title}</Link></dd>
                    <dt>Status</dt>
                    <dd>{details.status}</dd>
                    <dt>Billing Cycle</dt>
                    <dd>{details.billing_cycle}</dd>
                    <dt>Billing Mode</dt>
                    <dd>{details.billing_mode}</dd>
                    {/* <dt>No Jobs</dt>
                    <dd>{details.no_jobs}</dd> */}
                    {/* <dt>Total Revenue</dt>
                    <dd>{UGX(details.total_revenue).format()}</dd> */}

                </dl>

                <ViewJobs jobs={details.jobs} />


            </div>

        </>
    )

}


/**
 * 
 * @param {Object} props
 * @param {import("../../resources/api/jobs").JobObject[]} props.jobs 
 * @returns 
 */
const ViewJobs = ({ jobs }) => {

    if (jobs.length === 0) return <></>

    return (
        <>
            <h4 className="mt-3 mt-md-5">Jobs</h4>
            <Table responsive hover size="sm" style={{ maxWidth: "800px", minWidth: "500px" }}>
                <thead>
                    <tr>
                        <th>Job</th>
                        <th>Date</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {jobs.map(e => (
                        <tr key={e.id}>
                            <td>
                                <Link to={`/app/jobs/${e.id}`} >{e.job_no}</Link>
                            </td>
                            <td>{moment(e.job_date).format("DD MMM YYYY")}</td>
                            <td>{UCWords(e.status?.replace(/-/g, " "))}</td>
                        </tr>
                    ))}
                </tbody>
                {/* <tfoot>
                    <tr>
                        <th colSpan={4}>Total</th>
                        <th className="text-end">{cur(jobs.reduce((p, c) => p + c.total_amount, 0), 0).format()}</th>
                        <th className="text-end">{cur(jobs.reduce((p, c) => p + c.balance, 0), 0).format()}</th>
                        <th />
                    </tr>
                </tfoot> */}
            </Table>
        </>
    )
}





const ProjectDetails = () => {

    const { projectid } = useParams();
    const [details, setDetails] = useState({});
    const [isLoaded, setLoaded] = useState(false);
    const [error, setError] = useState();


    useEffect(() => {

        setLoaded(false);
        setError(null);

        // const sortFn = (a, b) => sortFunction(a, b, 'job_date', "asc");

        getProject(projectid, ['client', 'jobs'])
            .then(({ project }) => {

                // const jobs = client.jobs.filter(j => (j.status !== 'cancelled'));
                // jobs.sort(sortFn);

                setDetails({ ...project });
            })
            .catch(e => setError(e))
            .finally(() => setLoaded(true));

    }, [projectid])

    //load events details

    if (!isLoaded) {
        return <PageLoading />
    }

    if (error) return <ErrorLoading>{error}</ErrorLoading>;

    return (
        <Routes>
            {/* <Route path="/generate-statement/*" element={<ClientStatement details={details} />} />
            <Route path="/statement" element={<ViewStatement details={details} />} /> */}
            <Route path="/edit" element={<EditProject details={details} setDetails={setDetails} />} />
            <Route path="/" element={<ViewDetails details={details} setDetails={setDetails} />} />
        </Routes>
    )

}


export default ProjectDetails;